import { Channel, Channel as ReturnChannel } from "@redotech/redo-model/return";
import { Condition } from "@redotech/redo-model/return-flow/condition";
import {
  channelFromModel,
  validateChannelCondition,
  type ChannelState,
} from "@redotech/redo-model/return-flow/condition-validate";
import { assertNever } from "@redotech/util/type";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const CHANNEL = (
  Details: React.ComponentType<ConditionTypeDetailsProps<ChannelState>>,
): ConditionType<ChannelState, Condition.Channel> => ({
  name: "Channel",
  description(state) {
    if (!state) {
      return "The channel through which the return was initiated";
    }
    switch (state) {
      case ReturnChannel.POINT_OF_SALE:
        return "Channel: Point of Sale";
      case ReturnChannel.WEB:
        return "Channel: Web";
      case ReturnChannel.SHOP_APP:
        return "Channel: Shop App";
      case ReturnChannel.AI:
        return "Channel: AI";
      case ReturnChannel.API:
        return "Channel: API";
      default:
        assertNever(state);
    }
  },
  Details(props: ConditionTypeDetailsProps<ChannelState>) {
    return React.createElement(Details, props);
  },
  empty: undefined,
  fromModel(model: Condition.Channel) {
    return channelFromModel(model);
  },
  toModel(state) {
    return { type: Condition.CHANNEL, channel: state ?? Channel.WEB };
  },
  valid(state) {
    return validateChannelCondition(state).valid;
  },
});

export { type ChannelState } from "@redotech/redo-model/return-flow/condition-validate";
